import { render, staticRenderFns } from "./EditButton.vue?vue&type=template&id=7b5d01d4&scoped=true&"
import script from "./EditButton.vue?vue&type=script&lang=js&"
export * from "./EditButton.vue?vue&type=script&lang=js&"
import style0 from "./EditButton.vue?vue&type=style&index=0&id=7b5d01d4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b5d01d4",
  null
  
)

export default component.exports